import {DOM} from "../utils/DOM";
import {CodeInputParams} from "../definitions/elements/codeInput/CodeInputParams";

export class CodeInput {

    public static init(params: CodeInputParams): void {

        const triggers = DOM.Parser.getHtmlElements('codeInput');
        for (let i = 0; i < triggers.length; i++) {
            const trigger = triggers[i] as HTMLFieldSetElement;
            this.initializeElement(trigger, params);
        }
    }

    public static showProgress(codeInputElement: HTMLElement) : void {

        codeInputElement.classList.add('busy');
        const inputs = DOM.Parser.getHtmlElementsByQuery('input', codeInputElement) as NodeListOf<HTMLInputElement>;
        for (let i = 0; i < inputs.length; i++) {
            inputs[i].disabled = true;
        }
    }

    public static hideProgress(codeInputElement: HTMLElement) : void {

        codeInputElement.classList.remove('busy');
        const inputs = DOM.Parser.getHtmlElementsByQuery('input', codeInputElement) as NodeListOf<HTMLInputElement>;
        for (let i = 0; i < inputs.length; i++) {
            inputs[i].disabled = false;
        }
    }

    private static initializeElement(trigger: HTMLFieldSetElement, params: CodeInputParams) {

        const inputElements = DOM.Parser.getHtmlElements('codeInput-input', trigger) as HTMLCollectionOf<HTMLInputElement>;

        // Focus first item
        const firstInputElement = inputElements[0];
        firstInputElement.focus();

        for (let i = 0; i < inputElements.length; i++) {

            const input = inputElements[i];
            input.addEventListener('keydown', (e: any) => {
                // if the keycode is backspace & the current field is empty
                // focus the input before the current. Then the event happens
                // which will clear the "before" input box.
                if(e.keyCode === 8 && e.target.value==='') inputElements[Math.max(0,i-1)].focus()
            });

            input.addEventListener('input', (e: any) => {

                // take the first character of the input
                // this actually breaks if you input an emoji like 👨‍👩‍👧‍👦....
                // but I'm willing to overlook insane security code practices.
                const [first,...rest] = e.target.value
                e.target.value = first ?? '' // first will be undefined when backspace was entered, so set the input to ""
                const lastInputBox = i===inputElements.length-1

                const didInsertContent = first!==undefined
                if(didInsertContent && !lastInputBox) {

                    // continue to input the rest of the string
                    inputElements[i + 1].focus()
                    inputElements[i + 1].value = rest.join('')
                    inputElements[i + 1].dispatchEvent(new Event('input'))
                } else if (lastInputBox) {
                    let finalValue: string = '';
                    for (let j = 0; j < inputElements.length; j++) {
                        const indexInputValue = inputElements[j].value.toString().trim();
                        if (indexInputValue.length === 0) { return; }
                        finalValue += indexInputValue;
                    }
                    params.finishCallback(finalValue);
                }
            });
        }
    }
}